const FontSizes = {
  buttonText: 20,
  logTitle: 44,
  bodyText: 14,
  iconSize: 20,
  groupCardText: 14,
  pageTitle: 16,
  calculateText: 24,
  dimensionText: 14,
  trackingLabel: 12,
  smallTrackingNumber: 12,
}

export default FontSizes;
